import React, { useState, useEffect, Fragment } from 'react';
import { useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import CommonOtpInput from '../../../../common/components/CommonOtpInput/CommonOtpInput';
import { ThrowError } from '../../../../common/constants/ThrowError';
import { Append_0 } from '../../../../common/constants/Append_0';
import { getConsumerOtp } from '../../../../common/constants/api';
import './Otp.css';
import CircularProgress from '@material-ui/core/CircularProgress';

const Otp = () => {
  const [otp, setOtp] = useState('');
  const [timeLeft, setTimeLeft] = useState(60);
  const [errMsg, setErrMsg] = useState('');
  const { setFieldValue, handleSubmit } = useFormikContext();
  const { values: wizardValues } = useFormikWizard();

  useEffect(() => {
    if (wizardValues?.loginSignUp?.isVerifiedByTruCaller) handleSubmit();
  }, []);
  const countDown = () => {
    if (timeLeft > 0) {
      setTimeLeft((timeLeft) => Append_0(timeLeft - 1, 2));
    }
  };

  useEffect(() => {
    let x = setInterval(() => countDown(), 1000);
    if (timeLeft === 0) clearInterval(x);
    return () => clearInterval(x);
  }, [timeLeft]);

  const resendOtp = () => {
    getConsumerOtp({
      email: wizardValues?.loginSignUp?.email,
      phone: wizardValues?.loginSignUp?.mbNo,
    })
      .then((res) => {})
      .catch((err) =>
        setErrMsg(
          err?.response?.data?.message ||
            'something went wrong! Please try again'
        )
      );
  };
  return (
    <Fragment>
      {wizardValues?.loginSignUp?.isVerifiedByTruCaller ? (
        <div className="flex items-center mx-auto  text-center w-full h-full">
          <div className="table mx-auto">
            <CircularProgress />
          </div>
        </div>
      ) : (
        <div className="w-full md:min-w-50v mx-auto">
          <p className="font-roboto font-normal  text-black-400 md:text-black-1011 text-xl md:text-2xl my-3">
            Please enter the 4-digit PIN we just sent to{' '}
            {[wizardValues?.loginSignUp?.mbNo].map(
              (s) =>
                s.slice(0, 2) +
                s.slice(2, 8).replace(/\d{5}$/, '*****') +
                s.slice(8)
            )}
          </p>
          <p className="text-grey-2232 font-roboto font-normal ">
            OTP Expires in :
            <span className="font-roboto font-medium text-xl text-orange-1100">
              {` 00:${timeLeft}`}
            </span>
          </p>
          <div
            className="text-center mx-auto "
            style={{ width: 'fit-content' }}
          >
            <CommonOtpInput
              length={4}
              className="otpContainer"
              inputClassName="otpInput"
              isNumberInput
              autoFocus
              onChangeOTP={(otp) => {
                setOtp(otp);
                setFieldValue('otp', otp, true);
                setErrMsg('');
              }}
            />

            <div
              className="text-orange-1100 text-sm md:text-base font-roboto font-medium ml-auto mt-5 "
              style={{ width: 'fit-content' }}
              onClick={() => {
                resendOtp();
                setTimeLeft(60);
                setErrMsg('');
              }}
            >
              RE-SEND OTP
            </div>
          </div>
          <div className="mt-16">
            <button
              type="submit"
              disabled={otp.length != 4}
              className="submitButton w-56"
            >
              Verify
            </button>
          </div>
          <ThrowError ErrMsg={errMsg} />
        </div>
      )}
    </Fragment>
  );
};

export default Otp;
